// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import type { MonthlyThumbsUpReport } from './types'
import moment from 'moment'
import sumBy from 'lodash/sumBy'
import css from './thumbsUpTable.css'
import WeekSummaryRow from './WeekSummaryRow'
import DayRow from './DayRow'
type ThumbsUpTableProps = {
  data: Array<MonthlyThumbsUpReport>
  year: number
}

const ThumbsUpTable = ({ data, year }: ThumbsUpTableProps) => {
  const monthlyTarget = sumBy(data, 'target')
  const monthlyActual = sumBy(data, 'actual')
  return (
    <table className={css.table}>
      <thead>
        <tr className={css.tableHead}>
          <th />
          <th>{i18n.t('reporting.label.thumbsUp.target')}</th>
          <th>{i18n.t('reporting.label.thumbsUp.actual')}</th>
        </tr>
      </thead>
      <tbody>
        <tr className={css.monthRow}>
          <td>{i18n.t('reporting.wholeMonth')}</td>
          <td>{monthlyTarget}</td>
          <td>{monthlyActual}</td>
        </tr>
        {data.map((singleDayData, index): any => {
          const isSunday = moment(singleDayData.date).day() === 0
          const weekData = data.slice(Math.max(index - 6, 0), index + 1)
          return (
            <React.Fragment key={`${singleDayData.week}${index}`}>
              <DayRow data={singleDayData} />
              {isSunday && <WeekSummaryRow data={weekData} week={singleDayData.week} />}
            </React.Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

export default ThumbsUpTable
